import { Manifest } from 'models/manifest';
import { GetManifestTypes, ManifestActionTypes } from '../actions/manifestConfig.action';

export interface ManifestConfigState {
  loading: boolean;
  error: string;
  manifestData: Manifest;
}

const initialState: ManifestConfigState = {
  loading: false,
  error: '',
  manifestData: {},
};

export default function reducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: ManifestActionTypes,
): ManifestConfigState {
  switch (action.type) {
    case GetManifestTypes.SEARCH_MANIFEST_CONFIG:
      return { ...state, loading: true };
    case GetManifestTypes.SEARCH_MANIFEST_CONFIG_SUCCESS:
      return { ...state, manifestData: action.payload.data, loading: false };
    case GetManifestTypes.SEARCH_MANIFEST_CONFIG_ERROR:
      return { ...initialState, error: action.payload.error, loading: false };

    default:
      return state;
  }
}
